import React, { useState, useEffect } from "react";
import { getDataWithEndpoint } from "../../../functions/request";
import {
  formatDateHourToBR,
  updateData,
} from "../../../functions/functionsUtility";
import { DescriptionMinMax } from "../../../layout";

const cortesType = [
  { label: "Novilhos Pesados", value: "boi_nov_pes" },
  { label: "Novillitos 300/350 kg", value: "boi_novi_350" },
  { label: "Novillitos 391/430 kg", value: "boi_novi_430" },
  { label: "Vaquillonas 300/340 kg", value: "boi_vaq_340" },
  { label: "Vaquillonas 391/430 kg", value: "boi_vaq_430" },
  { label: "Terneiros:", value: "boi_tern" },
];

export default function InterboisLiners() {
  const [cotacoesData, setCotacoesData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getDataWithEndpoint("boi_liners", "getBoiLiners", "updateBoiLiners")
      .then((data) => {
        setCotacoesData(data);
      })
      .finally(() => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setHasError(err?.message ?? "Ocorreu um erro.");
        console.log(err);
      });
  }, []);

  return (
    <>
      <DescriptionMinMax
        title={"Interbois - Boi Liners (VALOR EM PESOS ARGENTINOS)"}
        onClickButton={async () => {
          updateData({
            ...cotacoesData,
            endpoint: "updateBoiLiners",
            path: "boi_liners",
          });
        }}
        buttonText={"Atualizar"}
        data={cortesType}
        defaultValueFromApi
        date={formatDateHourToBR(cotacoesData.boi_data)}
        state={cotacoesData}
        setState={setCotacoesData}
        isLoading={isLoading}
        hasError={hasError}
        hasValue={false}
      />
    </>
  );
}
